import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { loadAnalytics, trackPageView } from '@/lib/analytics';

/** Loads GA4 once and sends a page_view on every SPA route change. */
export const Analytics = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    loadAnalytics();
  }, []);

  useEffect(() => {
    trackPageView(`${pathname}${search}`, document.title);
  }, [pathname, search]);

  return null;
};
